<template>
  <div class="user-page full-height">
        <full-con>
            <div slot="full">
                <el-row>
                    <el-col :span='12' class="fz ta-c">
                        {{$t('OrderBill.OrderBill2')}}:
                    </el-col>
                    <el-col :span='12' class="fz ta-c">
                        {{paymentInfo.paymentNumber}}
                    </el-col>
                </el-row>
                <el-row class="mt-10">
                    <el-col :span='12' class="ta-c">
                        {{$t('OrderBill.OrderBill1')}}:
                    </el-col>
                    <el-col :span='12' class="ta-c">
                        <span v-if="paymentInfo.orderType === '0'">FBA</span>
                        <span v-if="paymentInfo.orderType === '1'">{{$t('payBills.payBills1')}}</span>
                        <span v-if="paymentInfo.orderType === '2'">{{$t('payBills.payBills2')}}</span>
                        <span v-if="paymentInfo.orderType === '3'">{{$t('payBills.payBills3')}}</span>
                    </el-col>
                </el-row>
                <el-row class="mt-10">
                    <el-col :span='12' class="ta-c">
                        {{$t('orderList.orderList2')}}:
                    </el-col>
                    <el-col :span='12' class="ta-c">
                        {{paymentInfo.orderNumber}}
                    </el-col>
                </el-row>
                <el-row class="mt-10">
                    <el-table
                        :data="tableData"
                        border
                        style="width: 100%">
                        <el-table-column :label="$t('wzbg.wz6')" type="index" align="center" width="110"></el-table-column>
                        <el-table-column
                        prop="payName"
                        :label="$t('OrderBill.OrderBill3')"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="price"
                        :label="$t('OrderBill.OrderBill4')"
                        width="price">
                        </el-table-column>
                        <el-table-column
                        prop="count"
                        :label="$t('excel.excel7')">
                        </el-table-column>
                        <el-table-column
                        prop="discountAmount"
                        :label="$t('OrderBill.OrderBill5')">
                        </el-table-column>
                        <el-table-column
                        prop="receivedAmount"
                        :label="$t('OrderBill.OrderBill6')">
                        </el-table-column>
                    </el-table>
                </el-row>
                <el-row class="mt-10">
                    <el-col :span='12' class="ta-c">
                        {{$t('payBills.payBills4')}}:
                    </el-col>
                    <el-col :span='12' class="ta-c">
                        {{paymentInfo.receivedAmount}}
                    </el-col>
                </el-row>
                <el-row class="mt-10">
                    <el-col :span='12' class="ta-c">
                        {{$t('OrderBill.OrderBill8')}}:
                    </el-col>
                    <el-col :span='12' class="ta-c">
                        {{paymentInfo.customerBalance}}
                    </el-col>
                </el-row>
                <el-row class="flex mt-150">
                    <el-button v-if="paymentInfo.paymentStatus === '0'" type="primary" @click="goPay" class="btn">{{$t('OrderBill.OrderBill10')}}</el-button>
                    <el-button v-if="paymentInfo.paymentStatus === '1'" type="info" disabled class="btn">{{$t('payBills.payBills5')}}</el-button>
                </el-row>
            </div>
        </full-con>
    </div>
</template>

<script>
export default {
    data () {
        return {
            paymentInfo: {},
            tableData: []
        }
    },
    created(){
        this.getInfo(this.$route.query.id)
    },
    methods:{
        // 获取页面信息
        getInfo(e){
            this.$http.get('/tongkun/payment/' + e).then(res=>{
                console.log('id',res)
                if(res.data.code === 200){
                    this.paymentInfo = res.data.data.paymentDeail
                    this.tableData = res.data.data.paymentItemList
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        goPay(){
            // if (this.paymentInfo.customerBalance > -100000) {
                this.$confirm(this.$t('OrderBill.OrderBill12'), this.$t('prompt.title'), {
                confirmButtonText: this.$t('submit'),
                confirmButtonClass: "form-btn btn-blue",
                cancelButtonText: this.$t('cancel'),
                cancelButtonClass: "form-btn btn-gray",
                type: "warning"
                }).then(() => {
                    const data = {
                        id: this.paymentInfo.id
                    }
                    this.$http.post('/tongkun/payment/pay', data).then(res=>{
                        if(res.data.code === 200){
                            this.$router.push({
                                name: 'buddleOrder'
                            })
                            this.$message.success(res.data.message)
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                })
            // }else{
            //     this.$message.error(this.$t('payBills.payBills6'))
            // }
        }
    }
}
</script>

<style lang="less" scoped>
.fz{
    font-size: 20px;
}
.mt-10{
    margin-top: 10px;
}
.mt-150{
    margin-top: 150px;
}
.ta-c{
    text-align: center;
}
.flex{
    display: flex;
    justify-content: center;
}
.btn{
    width: 300px;
}
</style>